import { HtmlContentHeuristic } from '../../../interfaces/html-content-heuristic';
import { background } from '../html-content-properties/background';

// break when the background color changes from transparent to a color, or from a color to a color, indicating a new section
export const breakOnBackgroundChange: HtmlContentHeuristic = {
  reason: 'background changed',
  evaluate: (next: Record<string, any>, prev: Record<string, any>) =>
    next.background != null &&
    (prev.background == null ||
     next.background !== prev.background),
  properties: [background]
};
